import { render } from "./FormCompleteHeader.vue?vue&type=template&id=4b53c58d&scoped=true"
import script from "./FormCompleteHeader.vue?vue&type=script&lang=js"
export * from "./FormCompleteHeader.vue?vue&type=script&lang=js"

import "./FormCompleteHeader.vue?vue&type=style&index=0&id=4b53c58d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b53c58d"

export default script